module.exports = __webpack_public_path__ + "img/Lifestyle.e27655d7.jpg";